import http from 'conversations-http/clients/http';
export const deleteFileUploadClient = ({
  fileIds
}) => {
  return http.post(`/filemanager/api/v3/files/delete`, {
    data: {
      files: fileIds
    }
  });
};